import { useEffect, useState } from "react";

export const useCountdown = ({ initialTime = 60, initialPaused = false } = {}) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const [paused, setPaused] = useState(initialPaused);

  useEffect(() => {
    if (timeLeft <= 0 || paused) return;
    
    const timerId = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timerId);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
    return () => clearInterval(timerId);
  }, [timeLeft, paused]);

  return {
    timeLeft,
    start: () => setPaused(false),
    pause: () => setPaused(true),
    restart: () => {
      setTimeLeft(initialTime);
      setPaused(false);
    },
  };
};
